import styled from 'styled-components';

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  position: relative;

  label {
    font-size: var(--font-medium);
    margin-bottom: 5px;
  }

  p {
    margin-top: 10px;
    font-size: var(--font-normal);
    color: var(--third-color);
    font-weight: 600;
    cursor: pointer;
  }

  select {
    color: var(--text-color);
    background: #fcfbfd;
    border: 1px solid #e5e7eb;
    border-radius: 15px;
    height: 60px;
    padding: 0 20px;
    font-size: var(--font-medium);
  }

  span {
    padding-top: 5px;
    padding-left: 5px;
    color: var(--color-error);
    font-size: var(--font-small);
  }

  .error-border {
    border: 1px solid var(--color-error);
  }

  .eye-icon {
    position: absolute;
    width: 16px;
    top: 35px;
    left: 94%;
    cursor: pointer;
  }

  .adjust {
    top: 70%;

    @media (max-width: 768px) {
      top: 75%;
    }
  }

  .alert {
    color: var(--color-sublabel);
    margin-left: -6px;
    margin-bottom: 10px;
    margin-top: -10px;
    font-size: 12px;
  }
`;
